var map = {
	"./1.jpg": 53,
	"./blog-1.jpg": 54,
	"./blog-2.jpg": 55,
	"./contact.jpg": 23,
	"./dress-1.jpg": 56,
	"./dress-2.jpg": 57,
	"./dress-3.jpg": 58,
	"./dress-4.jpg": 59,
	"./feature-0.jpg": 32,
	"./feature-1.jpg": 60,
	"./feature-2.jpg": 61,
	"./feature-3.jpg": 62,
	"./feature-4.jpg": 63,
	"./magazine-1.jpg": 64,
	"./magazine-2.jpg": 65,
	"./magazine-3.jpg": 66,
	"./magazine-4.jpg": 67,
	"./master-head.jpg": 24,
	"./profile-1.jpg": 68,
	"./profile-2.jpg": 69,
	"./profile-3.jpg": 70,
	"./profile-4.jpg": 71,
	"./seminar-1.jpg": 72,
	"./seminar-2.jpg": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;